import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'; // ✅
import axios from 'axios';
import './InstructorAbout.css';
import { useAuth } from '../../context/AuthContext';
import api from '../../api';
import { getProfilePictureUrl } from '../../utils/apiHelper';
import defaultProfilePic from '../../assets/defaultProfilePic.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import InstaTopbar from '../InstaTopbar/InstaTopbar';
const InstructorAbout = () => {
  const { profile, token } = useAuth();
  const navigate = useNavigate(); // ✅
  const [about, setAbout] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState({ bio: false, aboutMe: false, socialLinks: false });
  const [formData, setFormData] = useState({ bio: '', aboutMe: '', linkedin: '', twitter: '', youtube: '' });

  useEffect(() => {
    const fetchAboutDetails = async () => {
      try {
        const res = await axios.get(api.getInstructorDetailsWithCourses(profile._id), {
          headers: { Authorization: `Bearer ${token}` },
        });

        const instructor = res.data.instructor;

        setAbout({
          name: instructor.name,
          profilePicture: instructor.profilePicture,
        });

        setFormData({
          bio: instructor.bio || '',
          aboutMe: instructor.aboutMe || '',
          linkedin: instructor.socialLinks?.linkedin || '',
          twitter: instructor.socialLinks?.twitter || '',
          youtube: instructor.socialLinks?.youtube || '',
        });
      } catch (err) {
        console.error('Failed to load instructor info', err);
      } finally {
        setLoading(false);
      }
    };

    if (profile?._id) fetchAboutDetails();
  }, [profile, token]);

  const handleToggleEdit = (field) => {
    setEditing((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // For bio, enforce max 20 words
    if (name === 'bio') {
      const words = value.trim().split(/\s+/);
      if (words.length > 20) return; // Do not update if more than 20 words
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    try {
      await axios.post(
        api.updateInstructorAbout,
        {
          userId: profile._id,
          aboutInstructor: {
            bio: formData.bio,
            aboutMe: formData.aboutMe,
            socialLinks: {
              linkedin: formData.linkedin,
              twitter: formData.twitter,
              youtube: formData.youtube,
            },
          },
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      setEditing({ bio: false, aboutMe: false, socialLinks: false });
      toast.success('Changes saved successfully!', { autoClose: 5000 });
    } catch (err) {
      console.error('Failed to save changes', err);
      alert('Failed to save. Try again.');
    }
  };


  if (loading) return <div className="about-loading">Loading...</div>;
  if (!about) return <div className="about-error">Instructor data not found.</div>;

  return (
    <div>
      <InstaTopbar />
      <div className="about-container">
      
        {/* 🔹 Info Icon for Navigation */}
        <button
          className="info-icon"
          onClick={() => navigate(-1)}
        >
        &times;
        </button>

        <div className="about-header">
          <img
            src={getProfilePictureUrl(about.profilePicture, api.img, defaultProfilePic, about.name)}
            alt={about.name}
            className="about-profile-pic"
          />
          <h1 className="about-name">{about.name}</h1>

          <div className="about-section">
            <h2 className="section-title">Bio</h2>
            <div className="about-section-row">
              {editing.bio ? (
                <>
                  <textarea
                    name="bio"
                    value={formData.bio}
                    onChange={handleChange}
                    rows={3}
                    placeholder="Write a short bio (max 20 words)"
                    className="bio-textarea"
                    style={{ height: '40px' }}
                 
                  />
                  <div className="bio-word-count">
                    {formData.bio.trim() === '' ? 0 : formData.bio.trim().split(/\s+/).length} / 20
                  </div>
                  <div className="icon-container" style={{ display: 'flex', marginLeft: '-40px' }}>
                    <FontAwesomeIcon
                      icon={faSave}
                      className="edit-icon"
                      onClick={handleSave}
                    />
                    <FontAwesomeIcon
                      icon={faTimes}
                      className="edit-icon cancel-icon"
                      onClick={() => setEditing((prev) => ({ ...prev, bio: false }))}
                      style={{ marginLeft: '8px', color: '#d9534f', cursor: 'pointer' }}
                    />
                  </div>
                </>
              ) : (
                <>
                  <p className="about-bio">{formData.bio || 'No short bio provided.'}</p>
                  <FontAwesomeIcon
                    icon={faEdit}
                    className="edit-icon"
                    onClick={() => handleToggleEdit('bio')}
                  />
                </>
              )}
            </div>
          </div>
        </div>

        <div className="about-section">
          <h2>About Me</h2>
          <div className="about-section-row">
            {editing.aboutMe ? (
              <textarea name="aboutMe" value={formData.aboutMe} onChange={handleChange} rows="5" />
            ) : (
              <p>{formData.aboutMe || 'No additional details available.'}</p>
            )}
            {editing.aboutMe ? (
              <>
                <FontAwesomeIcon
                  icon={faSave}
                  className="edit-icon"
                  onClick={handleSave}
                />
                <FontAwesomeIcon
                  icon={faTimes}
                  className="edit-icon cancel-icon"
                  onClick={() => setEditing((prev) => ({ ...prev, aboutMe: false }))}
                  style={{ marginLeft: '8px', color: '#d9534f', cursor: 'pointer' }}
                />
              </>
            ) : (
              <FontAwesomeIcon
                icon={faEdit}
                className="edit-icon"
                onClick={() => handleToggleEdit('aboutMe')}
              />
            )}
          </div>
        </div>

        <div className="about-social">
          <h2>Social Links</h2>
          <div className="about-section-row">


            {editing.socialLinks ? (
              <div className="about-social-form">
                <input type="url" name="linkedin" placeholder="LinkedIn" value={formData.linkedin} onChange={handleChange} />
                <input type="url" name="twitter" placeholder="Twitter" value={formData.twitter} onChange={handleChange} />
                <input type="url" name="youtube" placeholder="YouTube" value={formData.youtube} onChange={handleChange} />
              </div>
            ) : (
              <div className="about-social-icons">
                {formData.linkedin && (
                  <a href={formData.linkedin} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-linkedin"></i>
                  </a>
                )}
                {formData.twitter && (
                  <a href={formData.twitter} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-twitter"></i>
                  </a>
                )}
                {formData.youtube && (
                  <a href={formData.youtube} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-youtube"></i>
                  </a>
                )}
              </div>
            )}

            {editing.socialLinks ? (
              <>
                <FontAwesomeIcon
                  icon={faSave}
                  className="edit-icon"
                  onClick={handleSave}
                />
                <FontAwesomeIcon
                  icon={faTimes}
                  className="edit-icon cancel-icon"
                  onClick={() => setEditing((prev) => ({ ...prev, socialLinks: false }))}
                  style={{ marginLeft: '-50px', color: '#d9534f', cursor: 'pointer' }}
                />
              </>
            ) : (
              <FontAwesomeIcon
                icon={faEdit}
                className="edit-icon"
                onClick={() => handleToggleEdit('socialLinks')}
              />
            )}
          </div>
        </div>

        <ToastContainer position="top-right" />
      </div>
    </div>
  );
};

export default InstructorAbout;
